import React, { useContext, useState } from "react";
import styles from "./Review.module.scss";
import { Context } from "../Store";
import { isMobile } from "react-device-detect";
import { trackEvent } from "../utils/helpers";

const ReviewB = () => {
  const state = React.useContext(Context);

  const [hoveredStars, setHoveredStars] = useState(0);

  const googleReviewUrl = state.googleurl;
  const otherReviewUrl = state.feedbackurl;
  const isUkStory = state.country === "uk";
  const handleStarClick = (starIndex) => {
    trackEvent("Google Review", "Circle Clicked", `${starIndex} Circle`);
    // if (!googleReviewUrl) return;
    if (isUkStory && googleReviewUrl) {
      window.open(googleReviewUrl, "_blank", "noopener,noreferrer");
    } else if (otherReviewUrl) {
      window.open(otherReviewUrl, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <>
      <div className={styles.reviewContainer}>
        <div className={styles.rateGoogle}>
          <h3>How do you like us?</h3>
          <p>
            {isUkStory ? "Select the pucks below and drop a Google review" : "Select the pucks below and drop a review"}
          </p>
          <div className={styles.stars} onMouseLeave={() => setHoveredStars(0)}>
            {[...Array(5)].map((_, index) => (
              <button
                key={index}
                type="button"
                className={`${styles.starButton} ${hoveredStars >= index + 1 ? styles.starActive : ""}`}
                onMouseEnter={() => setHoveredStars(index + 1)}
                onClick={() => handleStarClick(index + 1)}
                aria-label={`Rate ${index + 1} stars`}
              >
                <img
                  src={`${process.env.PUBLIC_URL}/img/${hoveredStars >= index + 1 ? "blue-puck" : "plain-puck"}.svg`}
                  alt=""
                  width="42"
                  height="42"
                />
              </button>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default ReviewB;
